// Helpers de anexo (extensao, deteccao de imagem, icone por tipo). Movidos para
// utils porque sao FUNCOES — `constants/Attachments.js` guarda apenas os valores
// constantes (limites, allowlist, mapa de icones).
import { ALLOWED_IMAGE_EXTENSIONS } from '@modules/tarefas/constants/Attachments'
// Reusa o mapa de icones por tipo do aawz-drive (mesma familia mdi-file-* +
// cores por tipo) em vez de duplicar — PR review (Herik). Os consumidores leem
// apenas `.name`/`.color`; o `size` do mapa e ignorado (passamos `:size`
// explicito no template).
import { AAWZ_DRIVE_FILE_ICONS_MAP } from '@modules/aawz-drive/constants/Text'

const DEFAULT_FILE_ICON = { name: 'mdi-file-outline', color: '#8E8E8E' }

/**
 * Extrai a extensao (lowercase, sem ponto) de um nome de arquivo.
 * Retorna '' quando nao ha extensao.
 */
export function getExtension(fileName) {
  if (!fileName || typeof fileName !== 'string') return ''
  const idx = fileName.lastIndexOf('.')
  if (idx === -1 || idx === fileName.length - 1) return ''
  return fileName.slice(idx + 1).toLowerCase()
}

/**
 * Decide se um anexo e imagem. Usa o mimeType quando disponivel
 * (`image/*`), caindo para a extensao do nome quando ausente.
 */
export function isImageAttachment({ mimeType = '', fileName = '' } = {}) {
  if (mimeType && mimeType.startsWith('image/')) return true
  return ALLOWED_IMAGE_EXTENSIONS.includes(getExtension(fileName))
}

/**
 * Retorna o icone ({ name, color }) para um anexo, por extensao do nome
 * (com fallback por mimeType de imagem). Baseado no mapa do aawz-drive.
 */
export function getAttachmentIcon({ fileName = '', mimeType = '' } = {}) {
  const ext = getExtension(fileName)
  if (AAWZ_DRIVE_FILE_ICONS_MAP[ext]) return AAWZ_DRIVE_FILE_ICONS_MAP[ext]
  if (isImageAttachment({ mimeType: mimeType, fileName: fileName })) {
    return { name: 'mdi-file-image', color: '#EA4335' }
  }
  return DEFAULT_FILE_ICON
}
